import { partial } from '../../../util/translation/translation';

const p = partial('validateErrors');
const validateTileForm = (values) => {
  const errors = {};
  if (!values.title) {
    errors.title = p('titleFieldEmpty');
  }
  if (!values.startDate) {
    errors.startDate = p('startDateFieldCantBeEmpty');
  }
  if (!values.goalCount) {
    errors.goalCount = p('goalCountFieldCantBeEmpty');
  }

  return errors;
};
export default validateTileForm;
